module.exports = __webpack_public_path__ + "img/arToFr.f2d63fc9.png";